module.exports = __webpack_public_path__ + "img/gp_main07.05cdcbd0.png";